export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  updateTime: string;
  tags: string[];
  chapters: number;
  views: string;
}

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', color: 'bg-rose-500' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', color: 'bg-amber-500' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line', color: 'bg-red-500' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', color: 'bg-indigo-500' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', color: 'bg-emerald-500' },
  { name: 'BL', slug: 'bl', icon: 'ri-star-line', color: 'bg-violet-500' },
  { name: '剧情', slug: 'drama', icon: 'ri-emotion-line', color: 'bg-cyan-500' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', color: 'bg-gray-700' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '某天成为公主',
    author: 'Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20illustration%20of%20elegant%20princess%20with%20long%20blonde%20hair%20in%20royal%20palace%20setting%2C%20soft%20romantic%20atmosphere%20with%20warm%20golden%20lighting%2C%20delicate%20facial%20features%2C%20ornate%20dress%20details%2C%20dreamy%20ethereal%20quality%2C%20clean%20composition%2C%20modern%20webtoon%20aesthetic%2C%20no%20text&width=600&height=800&seq=cover-comic-1-a7x9&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.8,
    description: '某天醒来发现自己变成了小说中的公主，而且还是个注定要被父亲杀死的悲惨角色。为了改变命运，她必须想办法获得那位冷酷父皇的爱。一部温暖治愈又充满戏剧性的宫廷恋爱漫画，画风精致唯美，剧情扣人心弦。',
    updateTime: '2026-07-02',
    tags: ['宫廷', '穿越', '父女', '治愈'],
    chapters: 186,
    views: '2.3亿',
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20portrait%20of%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%2C%20intense%20battle%20atmosphere%2C%20dramatic%20lighting%20with%20shadows%2C%20dynamic%20composition%2C%20dark%20fantasy%20vibe%2C%20modern%20webtoon%20art%20style%2C%20clean%20design%2C%20no%20text&width=600&height=800&seq=cover-comic-2-b3k1&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '已完结',
    rating: 4.9,
    description: '在一个突然出现怪物的世界里，被称为"人类最弱兵器"的成振宇在一次濒死经历后获得了"系统"的能力，从此踏上了不断变强的道路。热血的战斗场面与紧张刺激的剧情让人欲罢不能。',
    updateTime: '2026-06-28',
    tags: ['系统', '升级', '热血', '怪物'],
    chapters: 200,
    views: '5.1亿',
  },
  {
    id: 'comic-3',
    title: '全知读者视角',
    author: 'Sing Shong / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20style%20portrait%20of%20ordinary%20office%20worker%20male%20protagonist%20surrounded%20by%20mysterious%20floating%20text%20and%20symbols%2C%20apocalyptic%20background%20hints%2C%20dramatic%20contrasting%20lighting%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-3-c5m2&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.7,
    description: '金独子是一个普通上班族，唯一的爱好就是阅读一部连载了十年的网络小说《在灭亡的世界中生存的三种方法》。当小说完结的那一天，小说中的世界竟然变成了现实，而他成为了唯一知道这个世界结局的人。',
    updateTime: '2026-07-03',
    tags: ['末世', '穿越', '系统', '群像'],
    chapters: 220,
    views: '3.8亿',
  },
  {
    id: 'comic-4',
    title: '恶女的定义',
    author: 'Lee Haron',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20portrait%20of%20elegant%20villainess%20female%20character%20with%20dark%20hair%20and%20red%20dress%20in%20royal%20palace%2C%20dramatic%20expression%2C%20luxurious%20setting%2C%20golden%20warm%20lighting%2C%20ornate%20details%2C%20modern%20webtoon%20art%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-4-d8n4&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.6,
    description: '穿越成小说中的恶毒女配后，为了不被处死，她决定洗白自己并远离男女主角。然而事情却朝着意想不到的方向发展——那个本该爱上女主的男主，为什么总是出现在她身边？',
    updateTime: '2026-07-01',
    tags: ['恶女', '穿越', '宫廷', '逆袭'],
    chapters: 145,
    views: '1.9亿',
  },
  {
    id: 'comic-5',
    title: 'SSS级自杀猎人',
    author: 'Shin Noah',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20portrait%20of%20male%20hunter%20with%20dark%20armor%20and%20sword%2C%20intense%20gaze%2C%20towering%20dungeon%20background%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20dynamic%20pose%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-5-e2p7&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.8,
    description: '在狩猎怪物的塔中，金公子是一个毫无存在感的F级猎人。但当他获得一个特殊技能——"复制死在自己面前的猎人的技能"后，他的命运彻底改变了。',
    updateTime: '2026-07-02',
    tags: ['塔', '升级', '复仇', '热血'],
    chapters: 168,
    views: '2.7亿',
  },
  {
    id: 'comic-6',
    title: '甜蜜家园',
    author: 'Kim Carnby / Hwang Young-chan',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20style%20portrait%20of%20young%20male%20character%20with%20haunted%20expression%2C%20dark%20apartment%20building%20background%2C%20ominous%20monster%20silhouette%2C%20cold%20blue%20lighting%2C%20tense%20atmosphere%2C%20modern%20webtoon%20style%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-6-f4t9&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    status: '已完结',
    rating: 4.7,
    description: '因校园暴力而自我封闭的少年车贤秀，在失去家人后搬到了一栋老旧公寓。不久后，一种恐怖的怪物化现象席卷了整个社会，公寓的居民们必须团结起来才能生存下去。',
    updateTime: '2026-06-15',
    tags: ['怪物', '末世', '生存', '群像'],
    chapters: 141,
    views: '3.2亿',
  },
  {
    id: 'comic-7',
    title: '女神降临',
    author: 'Yaongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20portrait%20of%20beautiful%20female%20student%20with%20makeup%2C%20school%20uniform%2C%20bright%20cheerful%20expression%2C%20soft%20pink%20cherry%20blossom%20atmosphere%2C%20warm%20lighting%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-7-g6w3&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '已完结',
    rating: 4.5,
    description: '因为长相平凡而遭受校园暴力的任朱静，通过化妆技术华丽变身成为校园女神。但在两个截然不同的男生面前，她必须在真实的自己和精心打造的完美形象之间做出选择。',
    updateTime: '2026-05-20',
    tags: ['校园', '化妆', '三角恋', '成长'],
    chapters: 230,
    views: '4.5亿',
  },
  {
    id: 'comic-8',
    title: '绿荫之冠',
    author: 'NAGO',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20style%20portrait%20of%20noble%20female%20character%20with%20green%20eyes%20and%20elegant%20gown%2C%20mysterious%20forest%20palace%20background%2C%20soft%20emerald%20green%20tones%2C%20magical%20atmosphere%2C%20delicate%20details%2C%20modern%20webtoon%20art%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-8-h1y5&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.6,
    description: '重生为帝国公爵家的私生女，为了摆脱被家族利用的命运，她决定伪装成一个对权力毫无兴趣的柔弱少女。但在那个充满阴谋与暗涌的宫廷中，隐藏真实自我远比想象中更加困难。',
    updateTime: '2026-07-01',
    tags: ['重生', '宫廷', '逆袭', '权谋'],
    chapters: 132,
    views: '1.6亿',
  },
  {
    id: 'comic-9',
    title: '杀死恶女',
    author: 'Kakao Entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20style%20portrait%20of%20fierce%20female%20character%20with%20determined%20expression%2C%20dark%20royal%20court%20background%2C%20deep%20purple%20and%20crimson%20color%20palette%2C%20dramatic%20shadows%2C%20intense%20gaze%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-9-i3r6&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 4.4,
    description: '在帝国中被称为"恶女"的艾莉丝，其实只是一个被所有人误解的可怜女子。当她决定不再忍耐，开始用自己的方式进行反击时，整个帝国的权力格局开始震动。',
    updateTime: '2026-06-30',
    tags: ['恶女', '宫廷', '复仇', '女性'],
    chapters: 98,
    views: '9.8千万',
  },
  {
    id: 'comic-10',
    title: '纳米魔神',
    author: 'Han Jung-wol',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20style%20portrait%20of%20male%20scientist%20with%20futuristic%20nanotechnology%20visual%20effects%2C%20glowing%20circuit%20patterns%2C%20dark%20laboratory%20background%2C%20cool%20cyan%20and%20silver%20tones%2C%20high%20tech%20atmosphere%2C%20modern%20webtoon%20style%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-10-j7u2&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 4.8,
    description: '顶尖科学家李玄在一场意外中被自己研发的纳米机器感染，获得了超凡的能力。但他很快发现，这项技术背后隐藏着一个足以毁灭世界的巨大阴谋。科技与人性的博弈就此展开。',
    updateTime: '2026-07-03',
    tags: ['科幻', '纳米', '阴谋', '超能力'],
    chapters: 76,
    views: '1.2亿',
  },
  {
    id: 'comic-11',
    title: '你们的王国',
    author: 'Son Gwan-geun',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20style%20portrait%20of%20three%20friends%20walking%20together%20in%20city%20street%2C%20warm%20sunset%20lighting%2C%20casual%20modern%20clothing%2C%20heartwarming%20atmosphere%2C%20urban%20Seoul%20background%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-11-k9o4&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    status: '连载中',
    rating: 4.3,
    description: '三个从小一起长大的好朋友，在成年后各自走上了不同的人生道路。但在生活的种种考验中，他们始终相互扶持，共同成长。一部温暖治愈的都市日常漫画。',
    updateTime: '2026-06-25',
    tags: ['友情', '都市', '成长', '治愈'],
    chapters: 54,
    views: '6.5千万',
  },
  {
    id: 'comic-12',
    title: 'BL星座',
    author: 'Gao',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20style%20portrait%20of%20two%20handsome%20male%20students%20in%20school%20uniform%2C%20soft%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20gentle%20spring%20lighting%2C%20delicate%20expressions%2C%20modern%20webtoon%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=cover-comic-12-l1s8&orientation=portrait',
    category: 'BL',
    categorySlug: 'bl',
    status: '连载中',
    rating: 4.5,
    description: '一次偶然的星座占卜让两个性格迥异的男生走到了一起。一个是理性冷静的学霸，一个是热情奔放的体育生，十二星座的奇妙力量将如何改变他们的命运？',
    updateTime: '2026-07-02',
    tags: ['校园', '星座', '甜宠', '青春'],
    chapters: 88,
    views: '1.1亿',
  },
];

export const featuredComics = comics.filter(c => c.rating >= 4.7);

export const latestUpdates = [...comics].sort((a, b) =>
  new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
);